import styled from 'styled-components';
import { PageContext } from '../../context/context';
import { useCallback, useContext } from 'react';
import CustomButton from '../UI/CustomButton/CustomButton';
import { fetchPost } from '../../services/fetchFunc';
import { useMutation } from '@tanstack/react-query';
import { AlertKeys } from '../UI/Alert/Alert.types';
import { PageKeys } from '../../App.types';

export function Cancel() {
    const {
        data,
        setAlert,
        setData,
        setPage,
        setErrorMessage,
        setSuccessMessage,
        data: appointmentData,
    } = useContext(PageContext);
    // const cancelAppointmentSession = window.sessionStorage.getItem(
    //     'cancelAppointmentSession',
    // );
    const id = new URLSearchParams(window.location.search).get('id');

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            fetchPost({
                id,
                action: 'cancel-appointment',
                // session: cancelAppointmentSession,
            }),
        onSuccess: (data) => {
            if (data?.error) {
                if (data?.error?.code == 401) {
                    setErrorMessage(data.error.message);
                    setPage(PageKeys.error);
                    setAlert(AlertKeys.none);
                } else {
                    setErrorMessage(data.error.message);
                    setPage(PageKeys.error);
                    setAlert(AlertKeys.none);
                }
            }
            if (data?.cancelled) {
                setData({ ...appointmentData, status: 'cancelled' });
                setSuccessMessage('Ваша запись отменена');
                setAlert(AlertKeys.success);
            }
        },
        onError: (err) => {
            if (err instanceof Error) {
                setErrorMessage(err.message);
                setPage(PageKeys.error);
                setAlert(AlertKeys.none);
                console.log(err.message);
            }
        },
    });

    const handleClickConfirm = useCallback(() => {
        mutate();
        console.log('handleClickBack');
    }, [mutate]);

    const handleClickBack = useCallback(() => {
        setAlert(AlertKeys.none);
        console.log('handleClickBack');
    }, [setAlert]);

    return (
        <StyledAlert>
            <StyledAlertTitile>Вы уверены?</StyledAlertTitile>
            <StyledData>
                <h3>Вы отменяете запись на прием:</h3>
                <StyledDataField>
                    <small>Пациент:</small>
                    <p>{`${data.patient}, ${data.birthday}`}</p>
                </StyledDataField>
                <StyledDataField>
                    <small>Услуга:</small>
                    <p>{data.title && data.title}</p>
                </StyledDataField>
                <StyledDataField>
                    <small>Дата:</small>
                    <p>{`${data.date && data.date} | ${
                        data.time && data.time
                    }`}</p>
                </StyledDataField>
                <StyledDataField>
                    <small>Врач:</small>
                    <p>{data.doctor && data.doctor}</p>
                </StyledDataField>
                <StyledDataField>
                    <small>Клиника:</small>
                    <p>{data.filial && data.filial}</p>
                </StyledDataField>
            </StyledData>

            <CustomButton
                disabled={isPending}
                onClick={handleClickConfirm}
                type={'third'}
            >
                Да
            </CustomButton>
            <CustomButton
                disabled={isPending}
                onClick={handleClickBack}
                type={'primary'}
            >
                Нет
            </CustomButton>
        </StyledAlert>
    );
}

const StyledAlertTitile = styled.div`
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    color: #0075ac;
    text-align: center;
    @media (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 16px;
    }
`;

const StyledAlert = styled.div`
    padding: 56px 80px;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
    max-width: 490px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (max-width: 768px) {
        max-width: 320px;
        gap: 16px;
        padding: 48px 15px;
    }
`;

const StyledDataField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    && small {
        font-weight: 700;
        font-size: 14px;
        line-height: 120%;
        color: #172945;
    }
    && p {
        font-weight: 400;
        font-size: 14px;
        line-height: 135%;
        color: #172945;
        margin: 0;
        padding: 0;
        text-align: left;
    }
`;
const StyledData = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    && h3 {
        font-weight: 700;
        font-size: 16px;
        line-height: 120%;
        color: #0075ac;
        margin-bottom: 16px;
    }
`;
